import { gsap } from 'gsap';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(ScrollSmoother, ScrollTrigger, SplitText);

export * from 'gsap';
export { ScrollSmoother, ScrollTrigger, SplitText };
